export const TRANSACTION_MANAGEMENT_CONSTANTS = {
    DEFAULT_USERS_PER_PAGE: 9,
    DEFAULT_TRANSACTIONS_PER_PAGE: 9,
    DEFAULT_SIDEBAR_WIDTH: '400px',
    SIDEBAR_MIN_WIDTH: 300,
    SIDEBAR_MAX_WIDTH_RATIO: 0.8,
    CONTAINER_HEIGHT: '95vh',
    SNACKBAR_DURATION: 6000,
    SEARCH_RESULTS_LIMIT: 100,
    
    MESSAGES: {
      CREDIT_ADJUSTMENT_SUCCESS: 'Credit adjustment successful',
      CREDIT_ADJUSTMENT_FAILED: 'Credit adjustment failed',
      NO_USER_SELECTED: 'Select a user to view transaction history'
    }
  } as const;